import { CONTACT } from "../../data/site";

const SITE = "Vata Infrastructures";

export const Seo = ({ title, description, path = "/", image = "/img/hero.jpg", jsonLd }) => {
  const origin = typeof window !== "undefined" ? window.location.origin : "";
  const url = `${origin}${path}`;
  const fullTitle = title ? `${title} | ${SITE}` : `${SITE} | Forest Fencing & Civil Contractor in Karnataka`;
  return (
    <>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:type" content="website" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={`${origin}${image}`} />
      <meta name="twitter:card" content="summary_large_image" />
      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </>
  );
};

export const businessJsonLd = () => ({
  "@context": "https://schema.org",
  "@type": "GeneralContractor",
  name: SITE,
  url: window.location.origin,
  image: `${window.location.origin}/img/hero.jpg`,
  logo: `${window.location.origin}/logo512.png`,
  telephone: "+91-97420-36439",
  email: CONTACT.email,
  foundingDate: "2018-10-10",
  founder: { "@type": "Person", name: "Darshan Bhaskar T" },
  address: {
    "@type": "PostalAddress",
    streetAddress: "766, 5th A Cross, Ashok Nagar, BSK 2nd Stage",
    addressLocality: "Bengaluru",
    addressRegion: "Karnataka",
    postalCode: "560050",
    addressCountry: "IN",
  },
  areaServed: { "@type": "State", name: "Karnataka" },
  knowsAbout: ["Chain link fencing", "Forest fencing", "Barbed wire fencing", "Elephant proof trench", "Railway barricade", "Wildlife holding rooms", "Dam gates", "Civil construction"],
});
